<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>新增资料</v-card-title>
        <div v-if="loading" class="d-flex justify-center my-4">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
        <v-card-text v-else>
          <!-- 目录选择 -->
          <v-select
            v-model="form.categoryId"
            :items="categories"
            item-text="name"
            item-value="categoryId"
            label="目录（必填）"
            outlined
            dense
            required
          ></v-select>
  
          <!-- 标签选择 -->
          <v-select
            v-model="form.tagId"
            :items="tags"
            item-text="name"
            item-value="id"
            label="选择标签"
            outlined
            dense
            multiple
          ></v-select>
  
          <!-- upload time -->
          <v-menu
                ref="uploadDateMenu"
                v-model="uploadDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedUploadDateTime"
                    label="上传时间"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="uploadDate"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="uploadDateMenu = false">取消</v-btn>
                  <v-btn text color="primary" @click="showTimePicker">
                    选择时间
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="uploadTimeMenu"
                v-model="uploadTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <v-time-picker
                  v-if="uploadTimeMenu"
                  v-model="uploadTime"
                  full-width
                  format="24hr"
                  use-seconds
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="uploadTimeMenu = false">取消</v-btn>
                  <v-btn text color="primary" @click="saveUploadDateTime">
                    确定
                  </v-btn>
                </v-time-picker>
              </v-menu>
          
          <!-- 上传档案 -->
          <v-file-input
            v-model="form.file"
            label="上传档案"
            accept="application/pdf"
            outlined
            dense
            show-size
          ></v-file-input>
        </v-card-text>
  
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- 取消按钮 -->
          <v-btn text @click="close">取消</v-btn>
          <!-- 保留按钮 -->
          <v-btn color="primary" @click="saveMaterial">保留</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { materialApi } from "@/api/material"; // 假设API封装在这里
  
  export default {
    name: 'CreateMaterialPopup',
    data() {
      return {
        loading: false,
        dialog: false,
        uploadDateMenu: false,
        uploadTimeMenu: false,
        categories: [],
        tags: [],
        dateMenu: false,
        uploadDate: null,
        uploadTime: null,
        form: {
          categoryId: null,
          tagId: [],
          uploadDate: null, // 默认当前时间 ISO 格式
          file: null,
        },
      };
    },
    computed: {
        formattedUploadDateTime() {
            if(!this.uploadDate || !this.uploadTime) return '';
            return `${this.uploadDate} ${this.uploadTime}`
        }
    },
    methods: {
      async open() {
        this.loading = true;
        this.dialog = true;
        try {
            await this.fetchCategories();
            await this.fetchTags();
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || '未知错误';
            this.$toast.error('获取详情失败：' + errorMessage);
        } finally {
            this.loading = false;
        }
      },
      close() {
        this.dialog = false;
        this.resetForm();
      },
        // 处理日期选择
    handleDatePick(date) {
        console.log('date = ', date);
        this.form.uploadDate = date; // 将选择的日期格式化为带时区的 ISO 8601 格式
        this.dateMenu = false; // 选完后自动关闭菜单
    },

    //   formatDate() {
    //     this.form.uploadDate = new Date(date).toLocaleString("sv-SE", { timeZone: "Asia/Shanghai" }).replace(" ", "T") + "+08:00";
    //   },
      showTimePicker() {
        this.uploadDateMenu = false;
      this.$nextTick(() => {
        this.uploadTimeMenu = true;
      });
      },
      saveUploadDateTime() {
        // 添加空值检查
        if (!this.uploadDate || !this.uploadTime) {
          this.uploadTime = null;
          this.uploadDate = null; // 同时清空日期
          this.uploadTimeMenu = false;
          return;
        }
        this.uploadTimeMenu = false;
      },
      resetForm() {
        this.form = {
          categoryId: null,
          tagId: [],
          uploadDate: null,
          file: null,
        };
      },
      async saveMaterial() {
        if (!this.form.categoryId || !this.form.file) {
          return alert("请填写完整信息");
        }
  
        try {
          // 格式化日期为 "YYYY-MM-DDTHH:mm:ss+08:00" 格式
          let formattedDate;
          if (this.uploadDate && this.uploadTime) {
            formattedDate = `${this.uploadDate}T${this.uploadTime}+08:00`;
          }
          await materialApi.createMaterial(
            this.form.categoryId, 
            {
                tagId: this.form.tagId,
                uploadDate: formattedDate,
                visible: true,
                file: this.form.file
            });
          this.$emit("create-material");
          this.close();
        } catch (error) {
          console.error("上传失败", error);
        }
      },
      async fetchCategories() {
        try {
            const response = await materialApi.getCategories();
            this.categories = response.data;
        } catch(error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
            this.$toast.error('获取资料信息失败：' + errorMessage);
        }
      },
      async fetchTags() {
        const response = await materialApi.getTags();
        this.tags = response.data;
      },
    },
  };
  </script>
  